export default function BrandPhilosophy() {
  const philosophies = [
    {
      icon: 'ri-fire-line',
      title: '野性即真实',
      desc: '放下伪装与期待，拥抱内心最原始的冲动。真正的美不在于迎合，而在于成为你自己。',
    },
    {
      icon: 'ri-scissors-cut-line',
      title: '剪断规则的锁链',
      desc: '谁说裙摆必须温柔？谁说女人必须乖巧？我们不设限，不定义，不妥协。',
    },
    {
      icon: 'ri-star-line',
      title: '在矛盾中绽放',
      desc: '优雅与野性的碰撞并非冲突，而是最迷人的和声。当一个女人学会在两者之间自由舞蹈，她便是不可战胜的。',
    },
  ];

  return (
    <section id="philosophy" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="font-heading text-accent-500 text-sm tracking-[0.2em] uppercase mb-3 whitespace-nowrap">
            Brand Philosophy
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            我们的<span className="text-primary-600">信仰</span>
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto leading-relaxed">
            「裙子下面是野兽」不是一个品牌，而是一种信仰 —— 相信每一位女性都拥有双面的美，而真正的力量来自两者的共生。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {philosophies.map((item, idx) => (
            <div
              key={item.title}
              className="group text-center p-8 md:p-10 rounded-lg bg-background-100 hover:bg-background-100 transition-colors duration-300 animate-fade-in"
              style={{ animationDelay: `${idx * 0.15}s`, opacity: 0 }}
            >
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}